export const DEFAULT_DASHBOARD_ID = 315;
